import { render, staticRenderFns } from "./TrainingVideos.vue?vue&type=template&id=01fb7af3&scoped=true"
import script from "./TrainingVideos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainingVideos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrainingVideos.vue?vue&type=style&index=0&id=01fb7af3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb7af3",
  null
  
)

export default component.exports